<template>
  <div v-if="isVisible" class="loading">
    <img src="@/assets/qc.gif" />
  </div>
</template>

<script>
export default {
  name: "LoadingPopup",

  data() {
    return {
      isVisible: false,
      count: 0
    }
  },

  methods: {
    showLoading() {
      if (!this.isVisible) {
        this.isVisible = true;
      }
      this.count++;
    },

    hideLoading() {
      this.count--;
      if (this.count <= 0) {
        this.count = 0;
        this.isVisible = false;
      }
    }
  },

  mounted() {
    // 挂载全局方法，外部可调用
    window.showLoadingPopup = this.showLoading;
    window.hideLoadingPopup = this.hideLoading;

    document.body.appendChild(this.$el);
  },

  beforeDestroy() {
    delete window.showLoadingPopup;
    delete window.hideLoadingPopup;

    // 从 body 移除 DOM
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
  }
}
</script>

<style scoped>
.loading {
  transition: all 0.3s ease-in-out;
  position: fixed;
  z-index: 999999;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.05);
}

.loading img {
  width: 200px;
  height: 194px;
  transform: scale(0.5);
  position: relative;
  top: -6%;
}
</style>


// WEBPACK FOOTER //
// src/components/Loading/index.vue